// extracted by mini-css-extract-plugin
module.exports = {"smaller-heading":"DonateNowForm_smaller-heading__mjCR4","custom-donation-label":"DonateNowForm_custom-donation-label___KK9d","donate-label":"DonateNowForm_donate-label__IaUND"};